import { NEW_OPENED_ID } from '../model';
import { stages } from '../types';

export const prepareDataToRequest = ({
  openedId,
  preload,
}: {
  openedId?: string | number | null;
  preload?: string;
}) => {
  const values = !!preload ? { values: JSON.parse(preload) } : {};

  if (openedId === NEW_OPENED_ID) return { stage: stages.class, ...values };

  return {
    stage: stages.ticket,
    data: openedId!,
    ...values,
  };
};
